import styled, { css } from 'styled-components'

const lineSize = (size: number, isRounded: boolean) => css`
	height: ${size}em;
	border-radius: ${isRounded ? size / 2 : 0}em;
	transform-origin: ${size / 2}em ${size / 2}em;
	left: ${0.7 - size / 2}em;
`

type Props = {
	bold: boolean
	isActive: boolean
	mirror?: boolean
	slim: boolean
	size: number
	isRounded: boolean
}

export const Line = styled.span<Props>`
	position: absolute;
	bottom: 0.1em;
	width: 0.6em;
	background-color: currentColor;
	transition: transform 0.15s;

	${({ slim, bold, size, isRounded }) => {
		if (slim) {
			return lineSize(0.05, isRounded)
		}
		if (bold) {
			return lineSize(0.15, isRounded)
		}
		return lineSize(size, isRounded)
	}}

	transform: ${({ mirror, isActive }) => {
		const offsetY = isActive ? -0.4 : 0
		const rotation = -90 + (mirror ? -1 : 1) * (isActive ? 135 : 45)

		return `translateY(${offsetY}em) rotate(${rotation}deg)`
	}}
`
